import { z } from 'zod';

import { Dimensions } from '../fields/Dimensions';
import { MountingType } from '../fields';
import { Weight } from '../fields/Weight';

export const mechanical = z
    .object({
        dimensions: Dimensions.validator.default({}),
        weight: Weight.validator.default({}),
        mountingType: MountingType.validator.optional().default([]),
    })
    .default({});
